<template>
  <ModalContainer queryParam="setDate" ref="modalContainer">

    <b-card class="mb-0">
      <!-- {{ itemLab }} -->
      <h4 class="modal-title mb-1">Programar Fecha</h4>

      <input 
        id="fecha-programada" 
        type="datetime-local" 
        v-model="fechaProgramada"
        class="form-control" 
      />

      <div class="d-flex justify-content-end mt-2">

        <b-button 
          class="mr-1"
          variant="secondary"
          @click="$refs.modalContainer.closeModal()"
        > 
          Cancelar 
        </b-button>

        <b-button 
          variant="primary"
          @click="saveFechaProgramada" 
        >
          Guardar
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from "@/shared/components";
import { labAuxiliarService } from "../../services";

export default {

  name: "ModalProgramarFecha",

  components: {
    ModalContainer
  },


  created() {
    this.getData()
  },


  data() {
    return {
      tokenAuxiliar: null,
      itemLab: null,

      fechaProgramada: null
    }
  },

  methods: {
    async getData() {
      this.fechaProgramada = null;
      
      this.tokenAuxiliar = this.$route.query.setDate;
      if(!this.tokenAuxiliar) return;

      const responseSearch = await labAuxiliarService.getAll({ tokenLaboratorio: this.tokenAuxiliar });

      if(!responseSearch || !responseSearch.data?.length) {
        await this.$swal({
          icon: 'error',
          title: 'No se encontro el auxiliar',
          showConfirmButton: true,
        });

        this.$refs.modalContainer.closeModal();

        return;
      }

      // this.itemLab = labAuxMapper(responseSearch.data[0]);
      const itemLab        = responseSearch.data[0]
      if(!itemLab || !itemLab.fechaProgramada) return;
      
      this.fechaProgramada = itemLab.fechaProgramada
    },


    async saveFechaProgramada() {
      
      const confirmation = await this.$swal({
        title: "¿Estás seguro de actualizar la fecha?",
        text: "No podrás deshacer esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, actualizar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmation.isConfirmed) return;

      const responseUpdate = await labAuxiliarService.updateByToken(this.tokenAuxiliar, { fechaProgramada: this.fechaProgramada });

      console.log('responseUpdate', responseUpdate);

      if (!responseUpdate) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
        });

        return;
      }

      await this.$swal({
        icon: "success",
        title: "Éxito",
        text: "La fecha se actualizó correctamente.",
      });

      await this.$refs.modalContainer.closeModal();
      this.$router.go(0);
    },

  },

  watch: {

    '$route.query.setDate': {
      handler(){
        this.getData();
      },
    },
  }
}
</script>
